var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"}),(_vm.text)?_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.$t(_vm.text))+"...")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }